import _ from 'lodash';
import React, { Component } from 'react';

import { getIcon } from '../../util/icons';

class StarRating extends Component {

  state = {
    hoveringRating: null
  }

  getClassForRating(rating, currentRating, maxRating){

    //check for perfect rating
    if(currentRating === maxRating){
      if(rating === maxRating){
        return 'star active selected perfect';
      }
      else{
        return 'star active perfect';
      }
    }

    //all non-perfect ratings
    if(rating < currentRating){
      return 'star active';
    }
    else if(rating === currentRating){
      return 'star active selected';
    }
    else{
      return 'star';
    }
  }

  renderRatingExplanation(){
    const { currentRating, ratingExplanations, ratingExplanation, includeRatingExplanationPlaceholder } = this.props;

    let explanation = null;

    if(!ratingExplanations && !ratingExplanation){
      return null;
    }
    //else if single explanation (for "locked in" ratings)
    else if(ratingExplanation){
      explanation = ratingExplanation;
    }
    else if(this.state.hoveringRating){
      explanation = ratingExplanations[this.state.hoveringRating - 1];
    }
    else if(ratingExplanations[currentRating - 1]){
      explanation = ratingExplanations[currentRating - 1];
    }

    if(explanation && explanation !== ''){
      return <div className="star-rating-explanation">{explanation}</div>;
    }
    else if(includeRatingExplanationPlaceholder){
      return <div className="star-rating-explanation">&nbsp;</div>;
    }
    else{
      return null;
    }
  }

  updateRating(num){

    const { updateRating } = this.props;

    if(typeof updateRating === 'function'){
      updateRating(num);
    }
  }

  renderRatingLabel(){
    const { ratingLabel } = this.props;

    if(!ratingLabel){ return null; }

    return <label>{ratingLabel}</label>
  }

  renderRatingStars(){

    const { updateRating, currentRating, maxRating } = this.props;

    let ratings = [];
    for (let i = 1; i <= (maxRating || 5); i++){
      ratings.push(i);
    }

    return (
      <div className={'star-rating' + (typeof updateRating === 'function' ? ' editable' : '')}>
        {_.map(ratings, num => {
          return <div
            onMouseEnter={() => { this.setState({hoveringRating: num}); }}
            onMouseLeave={() => { this.setState({hoveringRating: null}); }}
            onClick={() => { this.updateRating(num) }}
            key={'star-' + num}
            className={this.getClassForRating(num, currentRating, maxRating)}
          >{getIcon('star')}</div>
        })}
      </div>
    );
  }

  render(){

    return (
      <div
        className={'star-rating-container ' + (this.props.className || '')}
      >
        {this.renderRatingLabel()}
        {this.renderRatingStars()}
        {this.renderRatingExplanation()}
      </div>
    )
  }
}
export default StarRating;



// WEBPACK FOOTER //
// ./src/components/shared/starRating.js